export const AgreementTraining = [
    { label: "MATRICULAS", value: "registrations" },
    { label: "PREGRADO REGULAR", value: "undergraduate-regular" },
    { label: "POSGRADO", value: "postgraduate" },
    { label: "CARRERAS PARA PERSONAS QUE TRABAJAN", value: "working-adult-programs" },
    { label: "EDUCACIÓN CONTINUA", value: "continuing-education" },
    { label: "PROGRAMA FORMACIÓN ADULTOS", value: "adult-training-program" },
    { label: "CENTRO DE IDIOMAS", value: "language-center" },
    { label: "FORMACIÓN CONTINUA", value: "continuous-training" },
    { label: "MAESTRÍA", value: "masters-degree" },
    { label: "DIPLOMADO Y CURSOS ESPECIALIZADOS", value: "diplomas-and-specialized-courses" },
    { label: "ESTUDIOS IN HOUSE", value: "in-house-studies" },
    { label: "CENTRO PRE UNIVERSITARIO", value: "pre-university-center" },
    { label: "PREGRADO", value: "undergraduate" },
    { label: "BACHILLERATO", value: "bachelor-degree" },
    { label: "EPE ONLINE", value: "epe-online" },
    { label: "PROGRAMA ONLINE", value: "online-program" },
    { label: "CURSOS ESPECIALIZADOS", value: "specialized-courses" },
    { label: "CURSOS DE CAPACITACIÓN", value: "training-courses" },
    { label: "DIPLOMADOS", value: "diplomas" },
    { label: "SIMPOSIOS", value: "symposiums" },
    { label: "PROGRAMAS DE PERFECCIONAMIENTO", value: "professional-development-programs" },
    { label: "COMPLEMENTACIÓN ACADÉMICA PROFESIONAL", value: "professional-academic-completion" },
    { label: "CURSOS DE EXTENSIÓN", value: "extension-courses" },
    { label: "PROGRAMA PARA ADULTOS QUE TRABAJAN", value: "adult-working-program" },
    { label: "2DA ESPECIALIZACIÓN", value: "second-specialization" },
    { label: "CARRERAS TECNICAS", value: "technical-careers" },
    { label: "PROGRAMAS Y CURSOS", value: "programs-and-courses" },
    { label: "CARRERAS BACHILLER", value: "bachelor-careers" },
    { label: "CURSOS", value: "courses" },
    { label: "FORMACIÓN EXPRESS", value: "express-training" },
    { label: "CURSOS O PROGRAMAS DE ESPECIALIZACIÓN", value: "specialization-courses-or-programs" }
];